// extracted by mini-css-extract-plugin
module.exports = {"deleteContainer":"styles_deleteContainer__1R5SB"};